/**
 * El motivo de un rechazo, en palabras del cliente. Mercado Pago manda
 * códigos como "cc_rejected_insufficient_amount" o "insufficient_amount"
 * según la API; se reconocen por la parte que importa.
 */
const MOTIVOS: Array<[RegExp, string, string]> = [
  [/insufficient/, 'Fondos insuficientes', 'La tarjeta no tiene saldo disponible para este monto.'],
  [/bad_filled|invalid_card|security_code|date/, 'Datos incorrectos', 'Revisa el número, el vencimiento o el código de seguridad.'],
  [/call_for_authorize/, 'Tu banco pide autorizarlo', 'Llama a tu banco para autorizar el pago y vuelve a intentarlo.'],
  [/card_disabled/, 'Tarjeta desactivada', 'Tu banco tiene esta tarjeta desactivada para compras en línea.'],
  [/max_attempts/, 'Demasiados intentos', 'Tu banco bloqueó la tarjeta por intentos seguidos. Prueba con otra.'],
  [/duplicated/, 'Pago duplicado', 'Tu banco lo tomó como un pago repetido. Prueba con otra tarjeta.'],
  [/high_risk|blacklist|fraud/, 'Rechazado por seguridad', 'El sistema antifraude no aprobó este pago. Prueba con otra tarjeta.'],
  [/rejected_by_issuer/, 'Rechazado por tu banco', 'Tu banco no aprobó el pago. Prueba con otra tarjeta o consulta con tu banco.'],
];

/**
 * `encabezado` es la frase grande de la pantalla. Cuando el problema no fue
 * la tarjeta sino el procesamiento (no_procesado), no se culpa al banco.
 */
export function explicarRechazo(detalle: string | undefined): { encabezado: string; titulo: string; texto: string } {
  if (detalle === 'no_procesado') {
    return {
      encabezado: 'No pudimos procesar el pago',
      titulo: 'No procesado',
      texto: 'Mercado Pago no pudo procesar este pago y no se hizo ningún cargo. Vuelve a intentarlo; si se repite, prueba con otra tarjeta.',
    };
  }
  for (const [patron, titulo, texto] of MOTIVOS) if (detalle && patron.test(detalle)) return { encabezado: 'Tu banco rechazó el pago', titulo, texto };
  return { encabezado: 'Tu banco rechazó el pago', titulo: 'Rechazado por el banco', texto: 'Tu banco no aprobó el pago. Prueba con otra tarjeta.' };
}
